export default __webpack_public_path__ + "static/media/mb3.59c8451a.jpg";